<div
  class="flex flex-col bg-[#EEF4FD] rounded pt-8 pb-8 pl-8 pr-8 items-center justify-center w-full max-w-[1280px] h-fit gap-[29px] min-[1024px]:rounded-lg min-[1024px]:pt-16 min-[1024px]:pb-16 min-[1024px]:pl-16 min-[1024px]:pr-16 min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:gap-0"
>
  <div class="flex flex-col w-full h-fit items-center gap-[31px] min-[1024px]:items-start">
    <!-- Heading -->
    <div class="flex flex-col items-start justify-start h-fit w-[278px] min-[1024px]:w-full">
      <span
        class="flex flex-wrap text-[#161C23] font-bold text-3xl leading-9 tracking-normal text-left w-fit h-fit min-[1024px]:text-4xl min-[1024px]:leading-10 min-[1024px]:w-full"
      >
        Sharing Is Caring
      </span>
    </div>

    <!-- Paragraphs + List -->
    <div
      class="flex flex-col items-start justify-start h-fit w-[278px] gap-6 min-[1024px]:w-full min-[1024px]:max-w-[896px] min-[1024px]:gap-[23.3px]"
    >
      @for (paragraph of paragraphs(); track $index) {
        <div class="flex flex-col items-start justify-start h-fit w-full">
          <p
            class="flex flex-wrap text-[#474747] font-normal text-base leading-[26px] tracking-normal text-left w-full h-fit min-[1024px]:text-lg min-[1024px]:leading-[29.25px]"
          >
            {{ paragraph }}
          </p>
        </div>
      }

      <!-- List -->
      <div
        class="flex flex-col items-start justify-start h-fit w-full pt-4 gap-4 min-[1024px]:gap-[15px]"
      >
        @for (item of listItems(); track $index) {
          <div
            class="flex flex-row items-start justify-start h-fit w-full gap-3 min-[1024px]:gap-4"
          >
            <!-- Bullet -->
            <div class="flex flex-col items-start justify-start h-full w-fit">
              <span
                class="flex flex-wrap text-black font-bold text-base leading-[26px] tracking-normal text-left h-[26px] w-[6px] min-[1024px]:text-lg min-[1024px]:leading-[29.25px] min-[1024px]:h-[30px] min-[1024px]:w-[7px]"
                >/</span
              >
            </div>
            <!-- Item text -->
            <div class="flex flex-col items-start justify-start h-full w-fit">
              <p
                class="flex flex-wrap text-[#474747] font-normal text-base leading-[26px] tracking-normal text-left h-fit min-[1024px]:text-lg min-[1024px]:leading-[29.25px]"
              >
                {{ item }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Image Row -->
    <div
      class="flex flex-col items-start justify-start h-fit w-[278px] pt-4 gap-4 min-[1024px]:flex-row min-[1024px]:flex-wrap min-[1024px]:w-full min-[1024px]:pt-[17px] min-[1024px]:gap-8 min-[1024px]:justify-center"
    >
      @for (imageItem of imageItems(); track $index) {
        <div
          class="relative flex flex-row items-center justify-center bg-[#DDE3EC] rounded border border-[#C6C6C6] h-[192px] w-full min-[1024px]:h-[320px] min-[1024px]:max-w-[460px] min-[1024px]:rounded-lg"
        >
          <!-- Icon centered -->
          <div
            class="flex flex-col items-start justify-start h-full w-full rounded min-[1024px]:rounded-lg"
          >
            @if (imageItem.iconSrc) {
              <img
                [src]="imageItem.iconSrc"
                [alt]="imageItem.label"
                class="h-full w-full rounded min-[1024px]:rounded-lg"
              />
            } @else {
              <div class="w-[27px] h-[27px] flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 27 27"
                  class="w-[27px] h-[27px] fill-black"
                >
                  <path
                    d="M13.5 2.25a11.25 11.25 0 1 0 0 22.5 11.25 11.25 0 0 0 0-22.5zm0 2.25a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 3.375a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25zm0 2.25a3.375 3.375 0 1 1 0 6.75 3.375 3.375 0 0 1 0-6.75z"
                  />
                </svg>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
